export const PotentialsType = {
    TEF_OFFERED: 'tef_offered',
    CALL_CENTER: 'call_center',
};
